import { makeRequestDeduped } from '../../infra/rest';
import requestConfig from '../config/request';
import { IntegrationAbilities, IntegrationAbilitiesResponse } from '../typings/integration-abilities';

export const getIntegrationAbilities = async (integrationId: string): Promise<IntegrationAbilities> => {
  const data = await makeRequestDeduped<IntegrationAbilitiesResponse>(
    `${requestConfig.aiBotBaseUrl}/v1/conversation-channel/capabilities?integrationId=${integrationId}`,
    undefined,
    true,
    false,
    true
  );
  return data.capabilities;
};
